import { atom } from "recoil";

// モーフィングAPI呼び出し可否の判定
export const sendableMorphingState = atom<boolean>({
  key: "sendableMorphingState",
  default: false,
});
